import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

import { useUserData } from '~/components/Header/menu/hooks/useUserData';
import useUserInfo from '~/hooks/useUserInfo';
import i18n from '~/lib/i18n';
import { resolveLanguageSetting } from '~/utils/language';

/**
 * Applies the language preference stored on the signed-in user. Until it is loaded the interface stays on
 * whatever i18next detected, so there is no flash of the wrong language on a reload.
 */
export const useApplyUserLanguage = () => {
    const user = useUserInfo();
    const { data: userData } = useUserData(user?.id);
    const setting = userData?.settings.language;

    useEffect(() => {
        if (setting === undefined) return;

        const language = resolveLanguageSetting(setting);
        if (i18n.language === language) return;

        i18n.changeLanguage(language).catch((error: unknown) => Sentry.captureException(error));
    }, [setting]);
};
